module.exports = __webpack_public_path__ + "img/mobile scanner stand02.9bc03310.jpg";